import { Database20Regular, Building20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const CompanyDatabasesPage = lazyPage(() => import('./tools/databases/pages/DatabasesPage'));
const CompanyRegistrationPage = lazyPage(() => import('./tools/registration/pages/CompanyRegistrationPage'));

const companyModuleConfig = createModuleConfig({
  key: 'company',
  name: 'Company',
  domain: { title: 'Company', icon: Building20Regular, shouldHide: true },
  tools: [
    {
      key: 'databases',
      name: 'Databases',
      title: 'Databases',
      path: '/company/databases',
      aliases: ['/databases'],
      element: <CompanyDatabasesPage />,
      nav: { name: 'Databases', icon: Database20Regular }
    },
    {
      key: 'registration',
      name: 'Registration',
      title: 'TPA Registration',
      path: '/company/registration',
      aliases: ['/company-registration'],
      element: <CompanyRegistrationPage />,
      nav: { name: 'Registration', icon: Building20Regular }
    },
  ],
});

export default companyModuleConfig;
